import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { AssetDto } from '@nusign/picflow-backend-types';
import { Subject, takeUntil } from 'rxjs';
import { simplifiedAssetNames } from '../../../lib/simplified-asset-names';
import { sleep } from '../../../lib/sleep';
import { AssetService } from '../../../services/asset.service';
import { ClickOutsideDirective } from '../../../shared-extra/directives/click-outside.directive';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { AssetUrlPipe } from '../../../shared/pipes/asset-url.pipe';

@Component({
  selector: 'app-thumbnail-bar',
  templateUrl: './thumbnail-bar.component.html',
  styleUrls: ['./thumbnail-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ClickOutsideDirective, SvgComponent, AssetUrlPipe, AsyncPipe],
})
export class ThumbnailBarComponent implements OnInit, OnChanges, OnDestroy {
  private check = inject(ChangeDetectorRef);
  private assetService = inject(AssetService);
  @ViewChild('bar') barEl: ElementRef<HTMLDivElement>;
  @Input() assets: AssetDto[];
  @Input() selectedAsset: AssetDto;
  @Output() onClose = new EventEmitter();
  @Output() onSwitchToAsset = new EventEmitter();
  simplifiedAssetNames = signal<{ [assetId: string]: string }>({});
  inView = signal<{ [assetId: string]: boolean }>({});
  destroyed$ = new Subject<void>();

  ngOnInit(): void {
    this.assetService.updates.pipe(takeUntil(this.destroyed$)).subscribe(() => {
      this.check.detectChanges();
    });
  }

  async ngOnChanges() {
    if (!this.selectedAsset) return;
    this.simplifiedAssetNames.set(simplifiedAssetNames(this.assets));
    await sleep(0);
    const selectedLeft = this.getSelectedLeft();
    this.barEl.nativeElement.scrollLeft = selectedLeft - window.innerWidth / 2 + 110 / 2;
    this.calcInView();
  }

  getSelectedLeft() {
    let left = 10;
    for (const asset of this.assets) {
      if (asset.id === this.selectedAsset.id) return left;
      left += 110 + 10;
    }
  }

  calcInView() {
    const inView = {};
    const left = this.barEl.nativeElement.scrollLeft;

    this.assets
      .filter((_img, index) => {
        const rel = 120 * index - left;
        if (rel < -120) return false;
        if (rel > window.innerWidth) return false;
        return true;
      })
      .forEach(asset => (inView[asset.id] = true));

    this.inView.set(inView);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
